import { Box, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useCheckout } from "components/StripeCheckout/useCheckout";
import { useSubscription } from "utils/useSubscription";

import styles from "../styles";

const AutopilotCard = () => {
  const { plans } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();
  const { getPromoCodeForPlan } = useCheckout();

  const promoCode = getPromoCodeForPlan(Plans.AUTOPILOT_YEARLY);

  if (!plans) return <></>;
  return (
    <Box
      sx={[
        styles.card,
        { background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)" },
      ]}
    >
      <Box sx={[styles.chip, { backgroundColor: "purple.main" }]}>
        <Box component="span" className="fa-solid fa-crown" /> Hands-off
        pitching for busy creators
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={6} container alignItems={"flex-end"}>
          <Typography component="div" sx={styles.planName} variant="h4">
            Autopilot
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Grid
            item
            xs={12}
            sx={styles.startAtText}
            justifyContent="flex-start"
            container
          >
            Starts at <br />
          </Grid>
          <Grid item sx={styles.priceText}>
            {promoCode && (
              <Box component="span">${getPrice(Plans.AUTOPILOT_YEARLY)}</Box>
            )}{" "}
            <Box component="span" sx={promoCode ? styles.strike : {}}>
              ${plans && plans[Plans.AUTOPILOT_YEARLY]?.price}/mo
            </Box>
          </Grid>
          {promoCode?.dateEnding && (
            <Grid item xs={12} justifyContent="flex-end" container>
              <Typography sx={{ color: "#d95e58", fontSize: 11 }}>
                until {promoCode?.dateEnding}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default AutopilotCard;
